import { render, staticRenderFns } from "./StockTrfDetails_Details.vue?vue&type=template&id=53ea89eb&"
import script from "./StockTrfDetails_Details.vue?vue&type=script&lang=js&"
export * from "./StockTrfDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports